export default __webpack_public_path__ + "static/media/sheba-home.9776752b.JPG";